import { render, staticRenderFns } from "./DailyScoreGarageDetail.vue?vue&type=template&id=80b3c56a&"
import script from "./DailyScoreGarageDetail.vue?vue&type=script&lang=js&"
export * from "./DailyScoreGarageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports